package editor.ui

object EditorUiHelper {
    fun idForName(name: String) = name.lowercase().replace(" ", "-").replace(".", "").replace("®", "")
}